/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sorx_Hint_DisabledInputs */

const en_sorx_hint_disabled = /** @type {(inputs: Sorx_Hint_DisabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Switch the channel back on or add a new channel below.`)
};

const id_sorx_hint_disabled = /** @type {(inputs: Sorx_Hint_DisabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nyalakan lagi kanalnya atau tambahkan kanal baru di bawah.`)
};

/**
* | output |
* | --- |
* | "Switch the channel back on or add a new channel below." |
*
* @param {Sorx_Hint_DisabledInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const sorx_hint_disabled = /** @type {((inputs?: Sorx_Hint_DisabledInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sorx_Hint_DisabledInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_sorx_hint_disabled(inputs)
	return en_sorx_hint_disabled(inputs)
});